import { Button } from 'konsta/react';
import Lottie from 'lottie-react';
import { FaTelegramPlane } from 'react-icons/fa';
import { FaChevronRight, FaTelegram } from 'react-icons/fa6';
import lottieBinance from '../lotties/etherium network-HKq7U.json';
import { useEffect } from 'react';
import { mixTrack } from '../helpers/MixPanelHelper';

const LandingPage = () => {
  useEffect(() => {
    mixTrack('[View] Landing');
  }, []);
  return (
    <>
      {/* Header */}
      <header className="absolute inset-x-0 top-0 z-50">
        <nav
          aria-label="Global"
          className="flex items-center justify-between p-6 lg:px-8"
        >
          <div className="flex lg:flex-1">
            <a href="#" className="-m-1.5 p-1.5">
              <span className="sr-only">MYNR</span>
              <img alt="" src="/logo.svg" className="h-8 w-auto" />
            </a>
          </div>
        </nav>
      </header>

      <main>
        {/* Hero section */}
        <div className="relative isolate pt-14">
          <svg
            aria-hidden="true"
            className="absolute inset-0 -z-10 h-full w-full stroke-primary/30 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]"
          >
            <defs>
              <pattern
                x="50%"
                y={-1}
                id="83fd4e5a-9d52-42fc-97b6-718e5d7ee527"
                width={200}
                height={200}
                patternUnits="userSpaceOnUse"
              >
                <path d="M100 200V.5M.5 .5H200" fill="none" />
              </pattern>
            </defs>
            <svg x="50%" y={-1} className="overflow-visible fill-primary/20">
              <path
                d="M-100.5 0h201v201h-201Z M699.5 0h201v201h-201Z M499.5 400h201v201h-201Z M-300.5 600h201v201h-201Z"
                strokeWidth={0}
              />
            </svg>
            <rect
              fill="url(#83fd4e5a-9d52-42fc-97b6-718e5d7ee527)"
              width="100%"
              height="100%"
              strokeWidth={0}
            />
          </svg>
          <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:flex lg:items-center lg:gap-x-10 lg:px-8 lg:py-40">
            <div className="mx-auto max-w-2xl lg:mx-0 lg:flex-auto">
              <div className="flex">
                <a
                  href={`https://t.me/${process.env.REACT_APP_CHANNEL_USERNAME}`}
                  className="relative flex items-center gap-x-4 rounded-full px-4 py-1 text-sm leading-6 text-gray-600 ring-1 ring-primary/10 hover:ring-gray-900/20"
                >
                  <span className="font-semibold text-primary">
                    Join Telegram channel
                  </span>
                  <span
                    aria-hidden="true"
                    className="h-4 w-px bg-gray-900/10"
                  />
                  <span className="flex items-center gap-x-1">
                    <FaTelegramPlane
                      aria-hidden="true"
                      className="-mr-2 h-5 w-5 text-primary"
                    />
                  </span>
                </a>
              </div>
              <h1 className="mt-10 max-w-lg text-4xl font-bold tracking-tight text-primary sm:text-6xl">
                Mine crypto in the cloud effortlessly with our solar panels.
              </h1>
              <p className="mt-6 text-lg leading-8 text-md-light-primary-container">
                Leverage the power of solar energy to mine cryptocurrency
                effortlessly in the cloud, reducing costs and maximizing
                sustainability.
              </p>
              <div className="mt-10 flex items-center gap-x-6 float-start">
                <Button
                  href={`https://t.me/${process.env.REACT_APP_BOT_USERNAME}`}
                >
                  Open in Telegram <FaTelegram className="ms-2 w-5 h-5" />
                </Button>
              </div>
            </div>
            <div className="mt-16 sm:mt-24 lg:mt-0 lg:flex-shrink-0 lg:flex-grow">
              <Lottie
                animationData={lottieBinance}
                className="w-80 h-80 lg:w-[600px] lg:h-[600px]"
              />
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default LandingPage;
